import { render } from "./JobView.vue?vue&type=template&id=a9b6924a&scoped=true"
import script from "./JobView.vue?vue&type=script&lang=js"
export * from "./JobView.vue?vue&type=script&lang=js"

import "./JobView.vue?vue&type=style&index=0&id=a9b6924a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9b6924a"]])

export default __exports__